import {
  GET_UPSELL_START,
  GET_UPSELL_FAILURE,
  GET_UPSELL_SUCCESS,
  GET_UPSELL_RESET,
} from "./constant"
const initialState = {
  UpSell: [],
  error: null,
  Loading: false,
  UpSellMsg: "",
  Lob: [],
  city: [],
}

const UpSellReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UPSELL_START:
      return {
        ...state,
        Loading: true,
        error: null,
      }

    case GET_UPSELL_SUCCESS:
      return {
        ...state,
        Loading: false,
        UpSell: action.payload,
      }

    case GET_UPSELL_FAILURE:
      return {
        ...state,
        Loading: false,
        error: action.payload.message,
      }
    case GET_UPSELL_RESET:
      return {
        UpSell: [],
        error: null,
        Loading: false,
        upSellMsg: "",
      }

    default:
      return state
  }
}

export default UpSellReducer
